export enum FactureExterneStatutEnum {
  A_TRAITER = 'A_TRAITER',
  VALIDEE_AUTOMATIQUEMENT = 'VALIDEE_AUTOMATIQUEMENT',
  VALIDEE_MANUELLEMENT = 'VALIDEE_MANUELLEMENT',
  REFUSEE = 'REFUSEE',
  ABANDONNEE = 'ABANDONNEE'
}

export const FACTURE_EXTERNE_STATUT_LABELS: Record<FactureExterneStatutEnum, string> = {
  [FactureExterneStatutEnum.A_TRAITER]:               'À traiter',
  [FactureExterneStatutEnum.VALIDEE_AUTOMATIQUEMENT]: 'Validée automatiquement',
  [FactureExterneStatutEnum.VALIDEE_MANUELLEMENT]:    'Validée manuellement',
  [FactureExterneStatutEnum.REFUSEE]:                 'Refusée',
  [FactureExterneStatutEnum.ABANDONNEE]:              'Abandonnée',
};
